import React from 'react';

interface PortalConfirmModalProps {
  open: boolean;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const PortalConfirmModal: React.FC<PortalConfirmModalProps> = ({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  danger = false,
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="portal-modal-overlay" onClick={onCancel}>
      <div className="portal-modal" onClick={(e) => e.stopPropagation()}>
        <h3 className="portal-modal-title">{title}</h3>
        <p className="portal-modal-message">{message}</p>
        <div className="portal-modal-actions">
          <button className="portal-btn portal-btn-secondary" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            className={`portal-btn ${danger ? 'portal-btn-danger' : 'portal-btn-primary'}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
